'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () {
                        return e[k];
                    }
                });
            }
        });
    }
    n['default'] = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

const Svg16 = (props) => (React__namespace.createElement("svg", Object.assign({ width: 16, height: 17, viewBox: "0 0 16 17", fill: "none" }, props),
    React__namespace.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.0004 8.99274C15.0004 12.8588 11.8663 15.9929 8.00019 15.9929C4.13409 15.9929 1 12.8588 1 8.99274C1 5.12664 4.13409 1.99255 8.00019 1.99255C11.8663 1.99255 15.0004 5.12664 15.0004 8.99274ZM8.98583 6.26596C8.98583 6.81068 8.54425 7.25226 7.99953 7.25226C7.45481 7.25226 7.01323 6.81068 7.01323 6.26596C7.01323 5.72124 7.45481 5.27966 7.99953 5.27966C8.54425 5.27966 8.98583 5.72124 8.98583 6.26596ZM8.00001 8.35095C8.49706 8.35095 8.90001 8.7539 8.90001 9.25095V11.8871C8.90001 12.3841 8.49706 12.7871 8.00001 12.7871C7.50295 12.7871 7.10001 12.3841 7.10001 11.8871V9.25095C7.10001 8.7539 7.50295 8.35095 8.00001 8.35095Z", fill: props.fillColor, fillOpacity: 0.92 })));

exports.default = Svg16;
//# sourceMappingURL=16.js.map
